import _ from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

// import BookingsGql from '@/extensions/eventManager/store/graphql/queries/Bookings.gql';
import BookingGql from '@/extensions/eventManager/store/graphql/queries/Booking.gql';
import BookingsPaginatedGql from '@/extensions/eventManager/store/graphql/queries/BookingsPaginated.gql';
import CreateBookingGql from '@/extensions/eventManager/store/graphql/mutations/CreateBooking.gql';
import UpdateBookingGql from '@/extensions/eventManager/store/graphql/mutations/UpdateBooking.gql';
import DeleteBookingGql from '@/extensions/eventManager/store/graphql/mutations/DeleteBooking.gql';
import ScanBookingGql from '@/extensions/eventManager/store/graphql/mutations/ScanBooking.gql';
import ResendBookingConfirmationGql from '@/extensions/eventManager/store/graphql/mutations/ResendBookingConfirmation.gql';

// Der Create/Update-Resolver braucht nur slot.id. Das komplette, aus den geladenen
// Daten stammende slot.event-Objekt (mit banner/slots/bookings/category) verletzt
// EX_EVNT_EventInput ("banner" ist dort nicht definiert) -> slot auf { id } reduzieren.
// Antworten auf das Anmeldeformular (values): gelesen kommen sie als { id, label, value, field },
// die Mutation liest je Eintrag field.id und value. Gesendet werden sie nur, wenn sie im Formular
// geändert wurden (valuesChanged). Sonst bleibt der gespeicherte Stand unangetastet und wird
// nicht bei jedem Speichern neu gegen ein evtl. geändertes Template geprüft.
const sanitizeBookingInput = booking => {
    if (!booking) return booking;

    const slotId = _.get(booking, 'slot.id');
    if (slotId !== undefined && slotId !== null) {
        booking.slot = { id: slotId };
    }

    if (booking.valuesChanged) {
        booking.values = (booking.values || [])
            .filter(value => _.get(value, 'field.id'))
            .map(value => ({
                field: { id: value.field.id },
                value: value.value,
            }));
    } else {
        delete booking.values;
    }
    delete booking.valuesChanged;

    return booking;
};

export default {
    // fetchList: (cmsID = null) =>
    //     new Promise((resolve, reject) => {
    //         let variables = {};
    //         if (cmsID) variables.cms = cmsID;
    //
    //         apolloClient
    //             .query({
    //                 query: BookingsGql,
    //                 variables
    //             })
    //             .then(({ data }) => resolve(data.EX_EVNT_Bookings))
    //             .catch(err => reject(err));
    //     })
    fetchBookingsPaginated: data =>
        new Promise((resolve, reject) => {
            let filters = [];
            _.each(data.filters, entry => filters.push(entry));

            apolloClient
                .query({
                    query: BookingsPaginatedGql,
                    variables: {
                        currentPage: _.get(data, 'pageInfo.currentPage', 1),
                        perPage: _.get(data, 'pageInfo.perPage', 25),
                        order: _.get(data, 'variables.order', 'id'),
                        direction: _.get(data, 'variables.direction', 'asc'),
                        link: _.get(data, 'link.route', '/event-manager/booking/'),
                        filters
                    }
                })
                .then(({ data }) => resolve(data.EX_EVNT_BookingsPaginated))
                .catch(err => reject(err));
        }),
    fetchBooking: id => {
        if (id === undefined) throw new Error('required argument is missing');

        let variables = { id: parseInt(id) };

        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: BookingGql,
                    variables
                })
                .then(({ data }) => resolve(data.EX_EVNT_Booking))
                .catch(err => reject(err));
        });
    },
    create: booking => {
        if (booking === undefined) throw new Error('required argument is missing');

        booking = sanitizeBookingInput(_.removeDeepByKey(booking, '__typename'));
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CreateBookingGql,
                    variables: { booking }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.EX_EVNT_CreateBooking);
                })
                .catch(err => reject(err));
        });
    },
    update: booking => {
        if (booking === undefined) throw new Error('required argument is missing');

        booking = sanitizeBookingInput(_.removeDeepByKey(booking, '__typename'));
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UpdateBookingGql,
                    variables: { booking }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.EX_EVNT_UpdateBooking);
                })
                .catch(err => reject(err));
        });
    },
    delete: id => {
        if (id === undefined) throw new Error('required argument is missing');

        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DeleteBookingGql,
                    variables: { id: parseInt(id) }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.EX_EVNT_DeleteBooking);
                })
                .catch(err => reject(err));
        });
    },
    // slotID is set when the operator picks the session themselves, after an "ambiguous" result.
    scan: (token, slotID = null) =>
        new Promise((resolve, reject) => {
            const variables = { token };
            if (slotID) variables.slot_id = parseInt(slotID);

            apolloClient
                .mutate({
                    mutation: ScanBookingGql,
                    variables
                })
                .then(({ data }) => resolve(data.EX_EVNT_ScanBooking))
                .catch(err => reject(err));
        }),
    resendConfirmation: id =>
        new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: ResendBookingConfirmationGql,
                    variables: { id: parseInt(id) }
                })
                .then(({ data }) => resolve(data.EX_EVNT_ResendBookingConfirmation))
                .catch(err => reject(err));
        })
};
